
import { defineComponent, computed } from "vue";
import Modal from "../Components/Modal.vue";
import RoomCard from "./RoomCard.vue";
import { useStore } from "../../stores";
import { ActionTypes } from "../../stores/action-types";
import router from "../../router";

export default defineComponent({
  name: "RoomModal",

  setup() {
    const store = useStore();
    const rooms = computed(() => store.state.rooms);
    const selectedRoomId = computed(() => store.state.selectedRoomId);
    return { rooms, selectedRoomId };
  },

  methods: {
    joinRoom() {
      if (this.selectedRoomId != null) {
        const store = useStore();
        this.$emit('close');
        store.dispatch(ActionTypes.ENTER_ROOM, this.selectedRoomId);
        router.push({ path: '/game' });
      } else {
        alert('Please select a room');
      }
    },
  },

  components: { Modal, RoomCard },
});
